module.exports = __webpack_public_path__ + "static/media/detailed_report.7f13ff7c.svg";